import {GetSeferData}   from "SeferPetach/GetData";

export async function getOrdersList(obj) {
    var payload = await GetSeferData("of1", obj);
    return (payload);
}
export async function getOrdersByIDSet(order_ids){
    var payload = await GetSeferData("rf1", {'ORDER_ID': order_ids});
    return (payload);
}